/** @format */

import ajax from '@src/ajax'

import {Api, ValidationRepository} from './ValidationRepository'

// Bounded to a form; interacts with the API
export class ProductionValidationRepository implements ValidationRepository {
  constructor(readonly formId: string) {}

  async getAll(): Promise<Api.ValidationRulesResponse> {
    return new Promise((resolve, reject) => {
      ajax({
        method: 'GET',
        endpoint: `/api-int/forms/${this.formId}/validation-rules`,
        onSuccess: resolve,
        onError: reject,
        errorMsg: 'Failed to fetch validation rules',
      })
    })
  }

  async updateValidations(
    input: Api.UpdateValidationPayloads,
  ): Promise<Api.ValidationRulesResponse> {
    return new Promise((resolve, reject) => {
      ajax({
        method: 'PUT',
        endpoint: `/api-int/forms/${this.formId}/validation-rules`,
        payload: input,
        onSuccess: resolve,
        onError: reject,
        errorMsg: 'Failed to update validation rules',
      })
    })
  }
}
